import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=2198aee5&scoped=true&"
import script from "./AdditionalInformation.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalInformation.vue?vue&type=style&index=0&id=2198aee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198aee5",
  null
  
)

export default component.exports